



































































import { editFactory } from '@/main/pages/editFactory';

import { FakturacniProfil } from './fakturacniProfil';
import { NahradniSazbaPujcovna } from './nahradniSazbaPujcovna';
import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: {
				FakturacniProfil: FakturacniProfil.name,
				NahradniSazbaPujcovna: NahradniSazbaPujcovna.name,
			},
		};
	},
	methods: {
		toggleVyrazenDateValue() {
			this.VyrazenDat = this.VyrazenDat ? null : new Date();
		},
	},
});
